import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Trash2 } from "lucide-react";
import FormField from "./FormField";
import { AUDIT_TYPES, SUB_STATUSES_QUALIFY } from "./constants";

export default function LeadOverviewTab({ detail, setDetail, me, ref_, canEdit, onSave, onDelete, saving }) {
  const isClient = detail.kind === "client";
  const stages = isClient ? (ref_.client_stages || []) : (ref_.stages || []);
  const subStatusOptions = SUB_STATUSES_QUALIFY;
  return (
    <div className="space-y-3 mt-4">
      <div className="grid md:grid-cols-2 gap-3">
        <FormField label="Organisation"><Input value={detail.org_name} disabled={!canEdit} onChange={(e) => setDetail({ ...detail, org_name: e.target.value })} /></FormField>
        <FormField label="ABN"><Input value={detail.abn || ""} disabled={!canEdit} onChange={(e) => setDetail({ ...detail, abn: e.target.value })} /></FormField>
        <FormField label="Contact name"><Input value={detail.contact_name} disabled={!canEdit} onChange={(e) => setDetail({ ...detail, contact_name: e.target.value })} /></FormField>
        <FormField label="Email"><Input value={detail.contact_email} disabled={!canEdit} onChange={(e) => setDetail({ ...detail, contact_email: e.target.value })} /></FormField>
        <FormField label="Phone"><Input value={detail.contact_phone || ""} disabled={!canEdit} onChange={(e) => setDetail({ ...detail, contact_phone: e.target.value })} /></FormField>
        <FormField label="State"><Input value={detail.state || ""} disabled={!canEdit} onChange={(e) => setDetail({ ...detail, state: e.target.value })} /></FormField>
        <FormField label="Stage">
          <Select value={detail.stage} disabled={!canEdit} onValueChange={(v) => setDetail({ ...detail, stage: v })}>
            <SelectTrigger data-testid="detail-stage"><SelectValue /></SelectTrigger>
            <SelectContent>{stages.map((s) => <SelectItem key={s.key} value={s.key}>{s.name}</SelectItem>)}</SelectContent>
          </Select>
        </FormField>
        <FormField label="Sub-status">
          <Select value={detail.sub_status || ""} disabled={!canEdit} onValueChange={(v) => setDetail({ ...detail, sub_status: v })}>
            <SelectTrigger><SelectValue placeholder="—" /></SelectTrigger>
            <SelectContent>
              {subStatusOptions.map((s) => (
                <SelectItem key={s || "none"} value={s || "none"}>{s || "None"}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FormField>
        <FormField label="Owner">
          <Select value={detail.owner_id} disabled={me.role !== "admin"} onValueChange={(v) => setDetail({ ...detail, owner_id: v })}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>{(ref_.users || []).map((u) => <SelectItem key={u.id} value={u.id}>{u.name}</SelectItem>)}</SelectContent>
          </Select>
        </FormField>
        <FormField label="Likely audit type">
          <Select value={detail.likely_audit_type} disabled={!canEdit} onValueChange={(v) => setDetail({ ...detail, likely_audit_type: v })}>
            <SelectTrigger><SelectValue /></SelectTrigger>
            <SelectContent>{AUDIT_TYPES.map((a) => <SelectItem key={a} value={a}>{a}</SelectItem>)}</SelectContent>
          </Select>
        </FormField>
        <FormField label="Notes" full>
          <Textarea rows={3} value={detail.notes || ""} disabled={!canEdit} onChange={(e) => setDetail({ ...detail, notes: e.target.value })} />
        </FormField>
      </div>
      <div className="flex justify-between pt-3">
        <Button variant="outline" onClick={onDelete} className="text-[#DC2626] border-[#DC2626]/40" disabled={!canEdit}>
          <Trash2 className="w-4 h-4 mr-2" />Delete
        </Button>
        <Button onClick={onSave} disabled={!canEdit || saving} className="bg-[#1A7F6E] hover:bg-[#136053] text-white" data-testid="save-lead-detail">
          {saving ? "Saving…" : "Save changes"}
        </Button>
      </div>
    </div>
  );
}
